// Wording follows the legacy system pages of track (system/user, system/device, admin/employee, system/unregistered).
export const LABELS_ADMIN_SYSTEM = {
	tabAccounts: "Акаунти",
	tabUsers: "Користувачі",
	tabDevices: "Об'єкти",
	tabEmployees: "Кадри",
	tabUnregistered: "Незареєстровані",
	tabUsersTitle: "Користувачі сервера",
	tabDevicesTitle: "Об'єкти сервера",
	tabEmployeesTitle: "Кадри сервера",
	tabUnregisteredTitle: "Незареєстровані об'єкти",
	filterAll: "Усі",
	filterActive: "Активні",
	filterInactive: "Неактивні",
	export: "Експорт",
	exportTooltip: "CSV з усіма записами за пошуком і фільтром",
	account: "Акаунт",
	back: "Назад",
	resetView: "Скинути вигляд",
	resetViewTooltip: "Повернути ширини колонок, видимі колонки, висоту рядків і сортування за замовчуванням",
	accountInactive: "Акаунт неактивний",
	status: "Статус",
	active: "Активний",
	inactive: "Неактивний",
	createdAt: "Дата створення",
	editAccount: "Редагувати акаунт",
	connectToAccount: "Підключитись до акаунта",
	connectAsUser: "Підключитись як {{login}}",
	openAccountLegacy: "Стара сторінка акаунта",
	editUser: "Редагувати користувача",
	openUserLegacy: "Стара сторінка користувача",
	editDevice: "Редагувати об'єкт",
	openDeviceLegacy: "Стара сторінка об'єкта",
	editEmployee: "Редагувати працівника",
	usersSearch: "Пошук за акаунтом, ім'ям для входу, П.І.Б. або ел. поштою",
	userLogin: "Ім'я для входу",
	userName: "П.І.Б.",
	userEmail: "Ел. пошта",
	userRole: "Роль",
	userDescription: "Статус користувача",
	userTimeZone: "Часовий пояс",
	userLastLogin: "Ост. вхід",
	userOnline: "Зараз в системі: {{count}}",
	devicesSearch: "Пошук за акаунтом, ід. об'єкта, описом, маркою, держ. номером, IMEI або телефоном",
	deviceCode: "Ід. об'єкта",
	deviceDescription: "Опис",
	deviceBrand: "Марка",
	deviceLicensePlate: "Держ. номер",
	deviceClass: "Клас",
	deviceColor: "Колір кузова",
	devicePhone: "Тел. номер приладу",
	deviceActiveUntil: "Активний до",
	deviceLastEvent: "Останні дані",
	employeesSearch: "Пошук за акаунтом, ім'ям, табельним номером, жетоном, телефоном або ел. поштою",
	employeeName: "Ім'я контакту",
	employeePersonnelNumber: "Табельний номер",
	employeeStatus: "Посада",
	employeeBadge: "Жетон",
	employeeCodeword: "Кодове слово",
	employeePhone: "Телефон",
	employeeEmail: "Ел. пошта",
	employeeActiveUntil: "Активний до",
	employeeStatusDRIVER: "Водій",
	employeeStatusCONDUCTOR: "Кондуктор",
	employeeStatusRESPONSIBLE: "Відповідальний",
	employeeStatusMECHANIC: "Механік",
	employeeStatusDOCTOR: "Доктор",
	employeeStatusMANAGER: "Диспетчер",
	employeeStatusSINGLE_VOYAGE_DRIVER: "Водій разового рейсу",
	employeeStatusPEDESTRIAN: "Пішохід",
	unregisteredSearch: "Пошук за IMEI або IP",
	unregisteredPort: "Порт",
	unregisteredFirstConnect: "Дата першої передачі",
	unregisteredLastConnect: "Дата останньої передачі",
	unregisteredConnections: "Кількість з'єднань",
	unregisteredDelete: "Видалити ({{count}})",
	unregisteredClear: "Очистити список",
	unregisteredDeleteTitle: "Видалити вибрані об'єкти зі списку?",
	unregisteredClearTitle: "Очистити список незареєстрованих об'єктів?",
	unregisteredDeleteText: "Трекер знову з'явиться у списку, коли наступного разу підключиться до сервера.",
	unregisteredDeleted: "Видалено зі списку: {{count}}",
	confirmDelete: "Видалити",
	cancel: "Скасувати",
	employeeNew: "Новий працівник",
	employeeNewHint: "Запис про співробітника",
	employeeCreate: "Зареєструвати",
	employeeNotFound: "Працівника не знайдено",
	employeeCardMain: "Співробітник",
	employeeCardDocuments: "Документи",
	employeeCardPhoto: "Фото",
	employeeCardAccess: "Доступ",
	employeeCardMobile: "Мобільний додаток",
	employeeFullName: "Контакт (Прізвище Ім'я Побатькові)",
	employeeShortName: "Прізвище та ініціали",
	employeeStatusLabel: "Статус працівника",
	employeeBadgeFull: "Особистий жетон працівника або ID-код",
	employeeBadgeHint: "Код персональної i-Button мітки або RFID мітки",
	employeePhoneInvalid: "Від 9 до 15 цифр, можна з «+» на початку",
	employeeEmailInvalid: "Некоректна ел. пошта",
	employeeBirthDate: "Дата народження",
	employeeCodewordHint: "Слово-ідентифікатор для ідентифікації особи по телефону",
	employeeAddress: "Адреса місця проживання",
	employeeNotes: "Примітки",
	employeeDriverClass: "Класс водія / Водійський стаж",
	employeeLicenseType: "Категорія посвідчення водія",
	employeeLicenseNumber: "Серія та номер водійського посвідчення",
	employeeLicenseStart: "Дата видачі посвідчення",
	employeeLicenseExpire: "Посвідчення дійсне до",
	employeePassport: "Серія та номер паспорта",
	employeeWorkStart: "Дата прийняття на роботу",
	employeeOrder: "№ наказу",
	employeeOrderHint: "№ наказу прийняття на роботу",
	employeePhotoSelect: "Виберіть зображення",
	employeePhotoHint: "JPEG або PNG до 512 КБ",
	employeeGroups: "Закріпити за групою",
	employeeWorksession: "Тип призначення на зміну",
	employeeWorksessionMANUAL: "Ручний",
	employeeWorksessionVOYAGE: "Рейс",
	employeeWorksessionRFID: "RFID",
	employeeConsolePassword: "Пароль для консолі",
	employeeConsolePasswordHint: "Пароль консолі водія",
	employeeMobileActive: "Доступ до мобільного додатку",
	employeeMobileActiveHint: "Увімкнеться функція відстеження особи за допомогою телефону",
	employeeMobileOnlyPedestrian: "Мобільний додаток доступний працівнику зі статусом «Пішохід».",
	employeeLogin: "Логін",
	employeePassword: "Пароль",
	employeePasswordNewHint: "Щонайменше 8 символів",
	employeePasswordHint: "Залиште порожнім, щоб не змінювати",
	employeeDeactivate: "Деактивувати",
	employeeDeactivateTitle: "Деактивувати працівника?",
	employeeDeactivateText: "Запис лишиться в системі неактивним: рейси й звіти й далі на нього посилаються. Його мобільний пристрій вимкнеться.",
	employeeDeactivated: "Працівника деактивовано",
	unitKmh: "км/год",
	unitSec: "с",
	unitM: "м",
	unitKm: "км",
	unitHours: "год",
	unitMin: "хв",
	unitDays: "дні",
	setting: {
		filterData: "Включити фільтрацію інформації про знаходження пристрою в повідомленнях",
		filterDataHint: "Невалідні повідомлення (викиди, без координат) не беруться до уваги в пробігу й звітах.",
		trackModeFix: "Режим побудови треку",
		trackModeFix_DEVICE_TIME: "За часом об'єкта",
		trackModeFix_SERVER_TIME: "За часом сервера",
		filterInvalid: "Пропускати невалідні повідомлення",
		filterInvalidHint: "Повідомлення з прапором невалідності не використовується для треку, але його датчики враховуються.",
		filterMinSatellites: "Мінімальна кількість супутників",
		filterMinSatellitesHint: "Рекомендоване значення — не менше трьох.",
		filterMaxHDOP: "Максимальне значення HDOP",
		filterMaxHDOPHint: "Чим менше значення, тим точніше визначені координати.",
		filterMaxSpeed: "Максимальне значення швидкості",
		filterMaxSpeedHint: "Повідомлення з більшою швидкістю маркуються як невалідні.",
		tripMethodOfMoving: "Спосіб фіксації руху",
		tripMethodOfMoving_GPS_SPEED: "GPS-швидкість",
		tripMethodOfMoving_GPS_POSITION: "GPS-координати",
		tripMethodOfMoving_IGNITION_SENSOR: "Датчик запалювання",
		tripMethodOfMoving_ODOMETER_SENSOR: "Датчик пробігу (одометр)",
		tripMethodOfMoving_RELATIVE_SENSOR: "Відносний одометр",
		tripMethodOfMoving_ACSELEROMETER: "Акселерометр",
		movingMinSpeed: "Мінімальна швидкість руху",
		movingMinSpeedHint: "Яку мінімальну швидкість вважати за початок руху.",
		movingMaxStopDuration: "Мінімальний час стоянки",
		movingMaxStopDurationHint: "Скільки об'єкт має простояти, щоб це була стоянка, а не зупинка. Мінімум 10 с.",
		movingGPScorrOn: "Активувати корекцію по GPS",
		movingGPScorrOnHint: "Актуальна для всіх способів фіксації, особливо для датчика запалювання; для одометра краще вимкнути.",
		movingMinSatellites: "Мінімальна кількість супутників",
		movingMinSatellitesHint: "Мінімальна кількість супутників, при якій дані валідні.",
		movingMinDistance: "Мінімальна відстань початку руху",
		movingMinDistanceHint: "Як далеко має переміститися об'єкт, щоб це був початок руху.",
		movingMaxDistanceBetweenMessages: "Максимальна відстань між повідомленнями",
		movingMaxDistanceBetweenMessagesHint: "Далі цієї відстані інтервал руху завершується й починається новий. Мінімум 50 м.",
		tripMinDuration: "Мінімальний час поїздки",
		tripMinDurationHint: "Скільки об'єкт має рухатися, щоб це була поїздка.",
		tripMinDistance: "Мінімальна відстань поїздки",
		tripMinDistanceHint: "Яку відстань має проїхати об'єкт, щоб це була поїздка.",
		filterBypassOnParking: "Ігнорувати фільтр швидкості при виїзді зі стоянки/парковки",
		filterBypassOnParkingHint: "Пропускає завищену швидкість першого повідомлення після стоянки, зберігаючи реальний пробіг.",
		speedLimitKPH: "Обмеження максимальної швидкості",
		speedLimitKPHHint: "Максимально допустима швидкість для даного об'єкта.",
		rptLimitSpeedCity: "Обмеження швидкості в населених пунктах",
		rptLimitSpeedCityHint: "До цієї швидкості рух вважається міським, вище — заміським.",
		rptDayEngineHR: "Добова норма мотогодин",
		rptDayEngineHRHint: "Використовується у звіті по мотогодинах.",
		rptFactorDist: "Коефіцієнт пробігу",
		rptFactorDistHint: "Для порівняння детектованого пробігу і пробігу по спідометру.",
		turboTimer: "Наявність турботаймера",
		rptTurboToArmed: "Затримка стану «Охорона»",
		odomCountingType: "Одометр пробігу",
		odomCountingType_GPS: "GPS координати",
		odomCountingType_GPS_AND_ACCELEROMETER: "GPS координати + датчик акселерометра",
		odomCountingType_GPS_AND_IGNITION: "GPS координати + датчик запалювання",
		odomCountingType_ABSOLUTE_ODOMETER: "GPS координати + датчик пробігу (абсолютний одометр)",
		odomCountingType_RELATIVE_ODOMETER: "GPS координати + датчик пробігу (відносний одометр)",
		lastGPSOdomKM: "Показ одометра пробігу",
		lastGPSOdomKMHint: "Зміна показу переписує одометр об'єкта.",
		vehicleCountingType: "Одометр мотогодин",
		vehicleCountingType_IGNITION: "Датчик запалювання",
		vehicleCountingType_ABSOLUTE_HOURS: "Датчик абсолютних мотогодин",
		vehicleCountingType_RELATIVE_HOURS: "Датчик відносних мотогодин",
		lastEngineHours: "Показ одометра мотогодин",
		countGprsTraffic: "Одометр GPRS трафіку",
		countDays: "Одометр добовий",
		countNotes: "Примітки",
		accessCode: "Код доступу до пристрою",
		accessCodeHint: "Пароль доступу до об'єкта для віддаленого управління (якщо необхідний).",
		controlNotes: "Примітки",
	},
	deviceNew: "Новий об'єкт",
	deviceNewHint: "Об'єкт створюється неактивним у групі «All» акаунта. Решту даних задасте на сторінці об'єкта.",
	deviceCreated: "Об'єкт створено",
	deviceMoved: "Об'єкт перенесено в {{code}}",
	deviceNotFound: "Об'єкт не знайдено",
	deviceMove: "Перенести",
	deviceMoveTitle: "Перенести {{code}} в інший акаунт?",
	deviceMoveText: "Об'єкт вийде з усіх груп і стане в групу «All» обраного акаунта разом із датчиками й калібруваннями. Збережіть зміни перед перенесенням.",
	deviceTabMain: "Головна",
	deviceTabFilter: "Фільтри",
	deviceTabTrip: "Детектор руху",
	deviceTabReport: "Дані для звітів",
	deviceTabCounter: "Одометри",
	deviceTabFuel: "Паливо",
	deviceTabSensor: "Датчики",
	deviceTabEmployee: "Кадри",
	deviceTabService: "Техобслуговування",
	deviceTabControl: "Управління",
	deviceTabField: "Довільні поля",
	deviceTabStyle: "Стилі",
	deviceCardMain: "Основні дані об'єкта",
	deviceCardStaff: "Штатні замовники Товариства/Штатний розпис",
	deviceCardTracker: "Трекер",
	deviceCardServer: "Сервер",
	deviceInactiveHint: "Неактивний об'єкт виходить з усіх груп",
	deviceCodeFull: "Унік. ід. об'єкта в акаунті",
	deviceCodeHint: "Ід. повинен бути унікальним в межах акаунта. Латиницею, без пробілів.",
	deviceDescriptionFull: "Опис об'єкта",
	deviceRequired: "Обов'язкове поле",
	deviceLicensePlateFull: "Держ. номер об'єкта",
	deviceLicensePlateHint: "Тільки латиниця — кирилиця замінюється автоматично.",
	deviceBrandFull: "Марка об'єкта",
	deviceClassFull: "Клас об'єкта",
	deviceClassHint: "Вантажівка, Автобус, Бус, Легковий автомобіль …",
	deviceVehicleId: "Тех. паспорт (ID) №",
	deviceActiveUntilFull: "Об'єкт активний до дати",
	devicePassengers: "Пасажиромісткість",
	deviceManufactureDate: "Дата виготовлення транспортного засобу",
	deviceClassiness: "Класність",
	deviceComposition: "Композитність",
	deviceHandicapped: "Низькопідлоговий",
	deviceRecordEvent: "Зберігання історії переміщень (запис треку)",
	deviceNotes: "Примітки",
	deviceStaffCustomer: "Перелік штатних замовників Товариства",
	deviceStaffAssignment: "Закріплення згідно штатного розпису",
	deviceGroups: "Закріпити за групою",
	deviceGroupsInactive: "Неактивний об'єкт не входить у групи",
	deviceImei: "Номер IMEI або ESN",
	deviceImeiHint: "Унікальний на сервері",
	deviceSerial: "Серійний номер пристрою (трекера)",
	deviceMainSim: "Тел. номер основної SIM",
	deviceAdditionalSim: "Тел. номер додаткової SIM",
	deviceLeasedSim: "Орендована",
	deviceSmsEmail: "Ел. пошта для відправки SMS",
	deviceMobileData: "Надсилання мобільних даних",
	deviceMobileDataMinutes: "Час початку надсилання моб. даних, хв",
	deviceWorkOrder: "Наряд-замовлення",
	deviceUniqueId: "Унік. ід. на сервері",
	deviceProtocol: "Тип сервера",
	deviceProtocolVersion: "Версія прошивки",
	userNew: "Новий користувач",
	userNewHint: "Оберіть акаунт, ім'я для входу й пароль. Решту даних задасте на сторінці користувача.",
	userLoginHint: "Ім'я повинно бути унікальним в межах акаунта. Латиницею, без пробілів.",
	userPassword: "Пароль для входу в систему",
	userCreated: "Користувача зареєстровано успішно",
	userDeleted: "Користувача видалено успішно",
	userNotFound: "Користувача не знайдено",
	userDeleteTitle: "Видалити користувача {{login}}?",
	userDeleteText: "Користувача, який створював маршрути, розклади чи геозони, видалити не можна — деактивуйте його.",
	usersDeleteInactive: "Видалити неактивних",
	usersDeleteInactiveTitle: "Видалити неактивних користувачів тенанта?",
	usersDeleteInactiveText: "Ті, хто створював маршрути, розклади чи геозони, залишаться.",
	usersInactiveDeleted: "Неактивні користувачі видалені. Видалено: {{count}}",
	userTabMain: "Головна",
	userTabTooltip: "Спливаюча підказка",
	userTabMap: "Відображення об'єктів",
	userTabFields: "Довільні поля",
	userCardMain: "Дані користувача",
	userCardAccess: "Права",
	userCardPreferences: "Налаштування",
	userContact: "Контакт",
	userEmailFull: "Ел. пошта користувача",
	userPhone: "Телефон користувача",
	userNotifyEmail: "Адреса ел. пошти для сповіщень",
	userGroup: "Авторизований для групи",
	userGroupAll: "Всі",
	userStaffAccessSet: "Доступ задано за штатним розписом",
	userStaffAccessNote: "Доступ за штатним розписом змінюється на старій сторінці користувача.",
	userAllowExport: "Дозволити експорт",
	userSpecRegime: "Дозволити встановлення спец режиму",
	userSpecRegimeHint: "Чи може користувач переводити машину в спец режим на стадіоні",
	userDriverMovement: "Доступ формування звіту \"Регулярність руху водіїв\"",
	userDriverMovementHint: "Чи може користувач формувати звіт \"Регулярність руху водіїв\"",
	userStartPage: "Початкова сторінка при вході в систему",
	userDefaultMap: "Карта за замовчуванням",
	userChatNotifications: "Сповіщення про повідомлення чату (звук і спливаючі вікна)",
	userPhotoRemove: "Прибрати",
	userTooltipTitle: "Дивитися / редагувати дані в підказці до об'єктів",
	userMapTitle: "Дивитися / редагувати дані відображення об'єктів на карті",
	userMapDriverName: "Замінювати імена об'єктів іменами водіїв",
	userMapDriverNameHint: "Імена об'єктів при їх відображенні на карті замінюються іменами водіїв, якщо такі призначені.",
	userMapGroup: "Групувати іконки об'єктів, які перекриваються",
	userMapGroupHint: "Якщо зображення двох і більше об'єктів «накладаються», вони замінюються однією іконкою.",
	userMapPath: "Слід за об'єктом",
	userMapPathHint: "Довжина сліду, що тягнеться за об'єктом (кількість точок відповідає кількості повідомлень).",
	userFieldsTitle: "Дивитися / редагувати довільні поля",
	userFieldTitle: "Назва",
	userFieldValue: "Значення",
	userFieldAdd: "Додати поле",
	startPage: {
		menu_top: "Робочий стіл",
		map_object: "Об'єкт на карті",
		map_group: "Група на карті",
		driver_info: "Водії",
		fuel_info: "Паливо",
		voyage_info: "Рейс",
		report_info: "Звіти",
	},
	map: {
		osm: "OpenStreetMap Default",
		trav: "MicroGIS",
		visicom: "Visicom",
		osmMapQuest: "OpenStreetMap MapQuest",
		gTer: "Google Physical",
		gRoad: "Google Streets",
		gSat: "Google Satellite",
		gHyb: "Google Hybrid",
		yndx: "Yandex Maps",
		ysat: "Yandex Satellite",
		yhyb: "Yandex Hybryd",
		ypub: "Yandex Public",
		ypubhyb: "Yandex Public Hybrid",
	},
	tooltip: {
		info: "Інформація про об'єкт",
		infoHint: "Тип пристрою, унікальний ID і телефонний номер, які задані у властивостях об'єкта.",
		lastDate: "Останні дані",
		lastDateHint: "Дата останнього повідомлення.",
		brand: "Марка",
		brandHint: "Марка об'єкта.",
		description: "Опис об'єкта",
		licensePlate: "Держ. номер об'єкта",
		group: "Група",
		groupHint: "Група об'єкта.",
		account: "Aкаунт",
		accountHint: "Aкаунт об'єкта.",
		showClass: "Клас",
		showClassHint: "Клас об'єкта.",
		fuelInTank: "Паливо",
		fuelInTankHint: "Рівень палива в баку.",
		staffCustomer: "Перелік штатних замовників Товариства",
		staffAssignment: "Закріплення згідно штатного розпису",
		parkingTown: "Місто стоянки",
		parkingAddress: "Адреса стоянки",
		position: "Положення",
		positionHint: "Остання визначена адреса місця розташування об'єкта.",
		speed: "Швидкість",
		speedHint: "Швидкість, зазначена в останньому повідомленні.",
		height: "Висота",
		heightHint: "Висота над рівнем моря (якщо пристрій передає такі дані).",
		satellite: "Супутники",
		satelliteHint: "Кількість супутників, які були захоплені в останньому повідомленні.",
		counter: "Одометри",
		counterHint: "Покази одометрів пробігу та мотогодин.",
		geozonePresence: "Присутність у геозонах",
		geozonePresenceHint: "Геозона, в межах якої об'єкт був в останньому повідомленні, її кольором.",
		option: "Параметри",
		optionHint: "Всі параметри, зазначені в останньому повідомленні, без перерахунку.",
		sensorValue: "Значення датчиків",
		sensorValueHint: "Датчики та їх значення, тобто інтерпретовані значення параметрів.",
		task: "Завдання",
		taskHint: "Призначені завдання і їх актуальний стан.",
		driver: "Водій",
		driverHint: "Ім'я, фотографія (якщо задана) і телефон водія, який керує об'єктом в даний момент.",
		maintenance: "Техобслуговування",
		maintenanceHint: "Задані сервісні інтервали і терміни їх виконання.",
		customFields: "Довільні поля",
		customFieldsHint: "Довільні поля з властивостей об'єкта зі значеннями.",
	},
}
